import PhoneConfirmationForm from './PhoneConfirmationForm';

export default PhoneConfirmationForm;
